import { useEffect, useState } from 'react';
import { adCreatives } from '../mocks/adPlacements';

interface AdDisplayProps {
  placementId: string;
  className?: string;
}

export default function AdDisplay({ placementId, className = '' }: AdDisplayProps) {
  const [currentAd, setCurrentAd] = useState<typeof adCreatives[0] | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Find ad for this placement
    const ad = adCreatives.find(a => a.placement === placementId);
    if (ad) {
      setCurrentAd(ad);
      setIsVisible(true);
    }
  }, [placementId]);

  const handleAdClick = () => {
    if (currentAd) {
      // Track click
      console.log('Ad clicked:', currentAd.advertiser);
      // Open link
      window.open(currentAd.linkUrl, '_blank', 'noopener,noreferrer');
    }
  };

  if (!currentAd || !isVisible) {
    return null;
  }

  return (
    <div className={`ad-container ${className}`}>
      <div className="text-xs text-gray-400 mb-1 text-center">Advertisement</div>
      <button
        onClick={handleAdClick}
        className="block w-full cursor-pointer hover:opacity-90 transition-opacity"
        aria-label={currentAd.altText}
      >
        <img
          src={currentAd.imageUrl}
          alt={currentAd.altText}
          className="w-full h-auto rounded-lg shadow-md"
          loading="lazy"
        />
      </button>
    </div>
  );
}